export function getEnv() {
  return import.meta.env.MODE
}
